import debounce from 'lodash/debounce';
import { useRef } from 'react';
import { gtmPushItemListView } from 'modules/gtm/modules/sections/productList/productList';
import { parseDataToGTMItemListView } from 'modules/gtm/utils/parsers';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { ClientPageType } from 'src/app/types';

export const useGTMItemListView = () => {
  const { gtmData } = useSiteConfig();
  const trackedProducts = useRef(new Set<number>());
  const newProducts = useRef(new Map<number, IAdaptedListProduct>());

  const filterNewProducts = (productsMap: Map<number, IAdaptedListProduct>) => {
    if (productsMap.size) {
      const products = [...productsMap.values()].filter(
        (item) => !trackedProducts.current.has(item.id),
      );

      return parseDataToGTMItemListView(products);
    }
    return null;
  };

  const pushItemsToGTM = debounce(
    (productsMap: Map<number, IAdaptedListProduct>) => {
      const parsed = filterNewProducts(productsMap);

      if (
        parsed?.items?.length &&
        gtmData?.pageType !== ClientPageType.PDP &&
        newProducts.current.size
      ) {
        gtmPushItemListView(parsed);
        trackedProducts.current = trackedProducts.current.union(
          new Set(newProducts.current.keys()),
        );
        newProducts.current = new Map();
      }
    },
    1000,
  );

  const addProductToGTMList = (product: IAdaptedListProduct) => {
    newProducts.current.set(product.id, product);

    pushItemsToGTM(newProducts.current);
  };

  return {
    addProductToGTMList,
  };
};
